<template>
  <div id="home">
    <Header />
    <div class="uk-card uk-padding uk-flex uk-flex-center uk-animation-fade" uk-height-viewport>
      <div class="uk-container uk-container">
        <div class="uk-grid-margin uk-grid uk-grid-stack uk-text-center" uk-grid>
          <h3 class="uk-card-title uk-text-center uk-text-bold uk-margin-remove-bottom">Bienvenue {{currentUser.firstName}} {{currentUser.lastName}}</h3>
        </div>
        <div class="uk-grid-margin uk-grid uk-grid-stack uk-text-center uk-margin-remove-top" uk-grid>
          <h6 class="uk-card-description uk-text-center">Vous êtes dans votre espace personnel.</h6>
        </div>

        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
          <div class="uk-width-auto" uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
            <div
              class="uk-width-large uk-card uk-card-primary uk-box-shadow-medium uk-border-rounded uk-card-hover"
            >
              <router-link to="/create-quotation">
                <img
                  class="uk-height-medium uk-flex uk-background-cover uk-light"
                  src="../assets/estimate.png"
                >
                  <h1 class="uk-text-center uk-text-middle uk-text-large uk-text-bolder uk-margin-bottom uk-text-uppercase">Obtenir une estimation</h1>
              </router-link>
            </div>
          </div>

          <div class="uk-width-auto" uk-scrollspy="cls: uk-animation-slide-right; repeat: true">
            <div
              class="uk-width-large uk-card uk-card-primary uk-box-shadow-medium uk-border-rounded uk-card-hover"
            >
              <router-link to="/my-documents">
                <img
                  class="uk-height-medium uk-flex uk-background-cover uk-light"
                  src="../assets/invoices.png"
                >
                  <h1 class="uk-text-center uk-text-middle uk-text-large uk-text-bolder uk-margin-bottom uk-text-uppercase">Mes documents</h1>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";

export default {
  name: "Home",
  components: {
    Header
  },
  data() {
    return {
      currentUser: {}
    };
  },

  mounted() {
    if (localStorage.getItem('currentUser')) {
      try {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      } catch(e) {
        localStorage.removeItem('currentUser');
      }
    }
  },

  methods: {
    addDelivery: function() {}
  }
};
</script>


<style scoped>
a {
  text-decoration: none;
}

.uk-card-primary {
  background-color: #dcc397
}

.uk-card-primary:hover {
  background-color: #234b70
}
</style>